import React, { useState, useEffect, useMemo } from "react";
import { WalletTransactions } from "../../pages/Wallet";
import { TransactionsController, WalletController } from "../../controllers";
import { transactionStore, walletStore } from "../../stores";
import { toJS } from "mobx";

const WalletTransactionsContainer = () => {
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [currencyCode, setCurrencyCode] = useState("NGN");

  const { selectedBusiness } = walletStore || {};

  const transactionTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}&currencyCode=${currencyCode}&business=${selectedBusiness._id}`;
  }, [currentPage, limit, currencyCode, selectedBusiness._id]);

  const { isLoading, data, isFetching, refetch } =
    TransactionsController.useGetAllTransactions(
      transactionTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  useEffect(() => {
    setLoading(true);
    const setWallet = async () => {
      const walletQuery = `business=${selectedBusiness._id}`;
      await WalletController.getBusinessWallet(walletQuery);
      setLoading(false);
    };
    setWallet();
  }, [selectedBusiness._id]);

  const filterHandler = async (query) => {
    setFilterQuery(query);
  };

  return (
    <WalletTransactions
      loading={loading}
      wallets={walletStore.wallets}
      walletBalance={toJS(walletStore.walletBalance)}
      transactions={toJS(transactionStore.transactions)}
      selectedBusiness={selectedBusiness}
      selectedBusinessWallet={walletStore.selectedBusinessWallet}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      setSearchQuery={setSearchQuery}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setFilterQuery={setFilterQuery}
      setCurrencyCode={setCurrencyCode}
      refetch={refetch}
      filterHandler={filterHandler}
    />
  );
};
export default WalletTransactionsContainer;
